<div class="theme_assesment p-3">
    <h1>Upload an Image and Choose a Color</h1>

    <div class="row">
        <div class="col-md-4">
            <label for="image">Logo image</label>
            <!-- <input type="file" name="image" id="image" accept="image/*" [(ngModel)]="selectedTheme.image" (change)="onFileSelected($event)"> -->
            <input type="file" name="image" class="form-control" id="image" (change)="onFileSelected($event)">
        </div>
        <div class="col-md-4">
            <label for="color">Theme color</label>
            <!-- <select name="color" class="form-control" id="color" [(ngModel)]="selectedTheme.color">
                <option value="default" selected>Default</option>
                <option value="red">Red</option>
                <option value="blue">Blue</option>
                <option value="orange">Orange</option>
            </select> -->
            <input type="color" name="color" class="form-control" id="color" [(ngModel)]="selectedTheme.color">
        </div>
        <div class="col-md-4">
            <label for="banner">Banner</label>
            <input type="file" name="banner" id="banner" class="form-control" accept="image/*"
                (change)="onBannerSelected($event)">
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12">

            <!-- <button pButton type="button" class="btn btn-primary mr-2" label="Upload"
                [loading]="isUploadLoader" (click)="changeTheme()" [disabled]="this.selectedTheme.image == null || this.selectedTheme.banner == null || this.selectedTheme.color == ''"></button> -->
            <!-- <button label="Search" [loading]="loading[3]" type="button" class="btn btn-primary mr-2"
                (click)="changeTheme()"
                [disabled]="this.selectedTheme.image == null || this.selectedTheme.banner == null || this.selectedTheme.color == ''">Upload</button> -->
            <button pButton class="btn btn-primary mr-2" type="button" label="Upload" [loading]="isUploadLoader"
                (click)="changeTheme()"
                [disabled]="this.selectedTheme.image == null || this.selectedTheme.banner == null || this.selectedTheme.color == ''"></button>
            <button pButton class="btn btn-primary" type="button" label="Reset" [loading]="isResetLoader"
                (click)="resetTheme()"
                [disabled]="isDefaultTheme"></button>
            <!-- <button type="button" class="btn btn-primary" (click)="resetTheme()"
                [disabled]="isDefaultTheme">Reset</button> -->
        </div>
    </div>
</div>